const str = (value) => (value === null || value === undefined ? "" : String(value));

// Code and Display Order left the form on 2026-10-15. A stored row may still
// carry them (the seeded DX001… codes), but nothing here reads, shows or sends
// them — the server leaves the stored values alone when a body omits the keys.
export const formStateOf = (row = {}) => ({
  name: str(row.name),
  category: str(row.category),
  siteType: str(row.siteType),
});

export const validateMasterForm = (form) => {
  if (!str(form.name).trim()) return "Diagnosis name is required.";
  return "";
};

export const buildMasterPayload = (form) => ({
  name: str(form.name).trim(),
  category: str(form.category).trim(),
  siteType: str(form.siteType).trim(),
});

export const reactivatePayload = (row) => ({
  ...buildMasterPayload(formStateOf(row)),
  isActive: true,
});

/** The Excel contract, mirrored by the server's services/dentalWorkspace/masterSheet.ts. */
export const SHEET_FILES = Object.freeze({
  template: "dental_diagnosis_template.xlsx",
  export: "dental_diagnosis_export.xlsx",
  columns: Object.freeze(["Diagnosis Name", "Category", "Site Type"]),
});

/** Failed rows plus the rows the sheet parser refused (Row, Diagnosis, Reason), in sheet order. */
export const importFailures = (data = {}) => {
  const failed = (Array.isArray(data?.results) ? data.results : [])
    .filter((item) => item?.status === "failed")
    .map((item) => ({
      row: Number(item.row) || null,
      name: str(item.name),
      reason: str(item.message) || "Could not import this row",
    }));

  const unreadable = (Array.isArray(data?.skippedRows) ? data.skippedRows : []).map(
    (item) => ({
      row: Number(item?.row) || null,
      name: str(item?.name),
      reason: str(item?.reason) || "Could not read this row",
    })
  );

  return [...failed, ...unreadable].sort(
    (a, b) => (a.row ?? Infinity) - (b.row ?? Infinity)
  );
};

export const importSummary = (data = {}) => {
  const { created = 0, updated = 0, skipped = 0, failed = 0 } = data || {};
  const unreadable = Array.isArray(data?.skippedRows) ? data.skippedRows.length : 0;
  const totalFailed = failed + unreadable;

  return {
    level: totalFailed > 0 ? "warning" : created + updated > 0 ? "success" : "info",
    message: `Import complete — ${created} created, ${updated} updated, ${skipped} skipped, ${totalFailed} failed.`,
  };
};
